var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"checkbox-button"},[_c('CButton',{attrs:{"color":_vm.checked ? _vm.color : '',"pressed":_vm.checked},on:{"click":function($event){return _vm.$emit('update:checked', !_vm.checked)}}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }